import React, { useState, useEffect } from 'react'
import { cityData } from './data'
import { Select } from 'antd'
import styles from './index.scss'
import User from '@/modules/user'

const ProvinceCityDropdown = ({ styleSmallFlag, showCityFlag, showProvinceNmFlag, onChildClick }) => {
  const [proVal, setProVal] = useState({ cd: undefined, nm: '' })
  const [cityVal, setCityVal] = useState({ cd: undefined, nm: '' })
  const [cityOption, setCityOption] = useState([])
  const user = new User()
  useEffect(() => {
    onChildClick({
      provinceCd: proVal.cd,
      cityCd: cityVal.cd,
      province: proVal.nm,
      city: cityVal.nm
    })
  }, [proVal, cityVal, onChildClick])

  const handleAreaRequest = async(cd = []) => {
    return user.getAreaData(cd.filter((c) => c !== '').join(',')).then((res) => {
      return res
    }).catch((err) => { console.log('err', err) })
  }

  const handleProvinceChange = async(cd) => {
    const findObj = cityData.find(val => val.cd === cd)
    setProVal({ cd: findObj.cd || undefined, nm: findObj.nm })
    setCityVal({ cd: undefined, nm: '' })
    cityOption.current = []
    const areaOption = await handleAreaRequest([cd])
    setCityOption(areaOption)
  }
  const handleCityChange = async(cd) => {
    const findObj = cityOption.find(val => val.cd === cd)
    setCityVal({ cd: findObj.cd || undefined, nm: findObj.nm })
  }
  return (
    <div className={styles['city']}>
      <Select placeholder='省' className={`${styles[!styleSmallFlag ? 'select-city-big' : 'select-city-small']} ${showProvinceNmFlag ? styles['red-border'] : ''}`} value={proVal.cd} onChange={handleProvinceChange}>
        {cityData.map(province => (
          <Select.Option key={province.cd + province.nm} value={province.cd}>
            {province.nm}
          </Select.Option>
        ))}
      </Select>
      <Select placeholder='市' className={`${styles[!styleSmallFlag ? 'select-city-big' : 'select-city-small']} ${showCityFlag ? styles['red-border'] : ''}`} value={cityVal.cd} onChange={handleCityChange} disabled={!proVal.cd}>
        {cityOption.length > 0 && cityOption.map(city => (
          <Select.Option key={city.cd + city.nm} value={city.cd}>
            {city.nm}
          </Select.Option>
        ))}
      </Select>
    </div>
  )
}

export default ProvinceCityDropdown
